import { baseTheme } from '@src/theme';
import { ESelectIntents } from '@src/typings';
import { Select, SelectProps } from 'antd';
import { createGlobalStyle, styled } from 'styled-components';

export const SelectOverrideStyles = createGlobalStyle`
  .ant-select-dropdown .ant-select-item-option {
    padding: 10px 12px;
    margin: 1px;
  }
  .ant-select-item.ant-select-item-option-selected .ant-space-item {
    color: ${(props) => props.theme?.colors?.primary?.main?.text || baseTheme.colors.primary.main.text};
  }
`;

export const StyledSelect = styled(Select)<
    SelectProps & { intent?: ESelectIntents; error?: boolean }
>`
    .ant-select-selector {
        border-radius: 8px;
        border-color: ${(props) => {
            if (props.error) {
                return (
                    props.theme?.colors?.error?.main?.border ||
                    baseTheme.colors.error.main.border
                );
            }
            if (props.bordered) {
                return (
                    props.theme?.colors?.secondary?.light?.border ||
                    baseTheme.colors.secondary.light.border
                );
            }
            return 'transparent';
        }} !important;
        box-shadow: none !important;
        border-radius: none !important;
        border-width: ${(props) => (props.bordered ? '1px' : '0')} !important;
        border-style: solid !important;
        border-color: ${(props) => {
            if (props.error) {
                return (
                    props.theme?.colors?.error?.main?.border ||
                    baseTheme.colors.error.main.border
                );
            }
            if (props.bordered) {
                return (
                    props.theme?.colors?.secondary?.light?.border ||
                    baseTheme.colors.secondary.light.border
                );
            }
            return 'transparent';
        }} !important;
        background-color: ${(props) => {
            switch (props.intent) {
                case ESelectIntents.default:
                    return (
                        props.theme?.colors?.secondary?.light?.contentBg ||
                        baseTheme.colors.secondary.light.contentBg
                    );
                case ESelectIntents.filled:
                    return (
                        props.theme?.colors?.secondary?.light?.surfaceBg ||
                        baseTheme.colors.secondary.light.surfaceBg
                    );
                case ESelectIntents.light:
                    return 'transparent';
                default:
                    return (
                        props.theme?.colors?.secondary?.light?.contentBg ||
                        baseTheme.colors.secondary.light.contentBg
                    );
            }
        }} !important;
    }

    .ant-select-selector:focus {
        border-color: ${(props) =>
            props.theme?.colors?.primary?.main?.border ||
            baseTheme.colors.primary.main.border} !important;
    }

    &:hover .ant-select-selector {
        border-color: ${(props) => {
            if (props.error) {
                return (
                    props.theme?.colors?.error?.main?.border ||
                    baseTheme.colors.error.main.border
                );
            }
            if (props.bordered) {
                return (
                    props.theme?.colors?.primary?.main?.border ||
                    baseTheme.colors.primary.main.border
                );
            }
            return 'transparent';
        }} !important;
    }

    .ant-select-selection-item {
        color: ${(props) => {
            switch (props.intent) {
                case ESelectIntents.default:
                    return (
                        props.theme?.colors?.secondary?.main?.text ||
                        baseTheme.colors.secondary.main.text
                    );
                case ESelectIntents.filled:
                    return (
                        props.theme?.colors?.secondary?.main?.text ||
                        baseTheme.colors.secondary.main.text
                    );
                case ESelectIntents.light:
                    return (
                        props.theme?.colors?.secondary?.light?.text ||
                        baseTheme.colors.secondary.light.text
                    );
                default:
                    return (
                        props.theme?.colors?.secondary?.main?.text ||
                        baseTheme.colors.secondary.main.text
                    );
            }
        }} !important;
    }

    .ant-select-selection-wrap {
        margin-top: 4px;
    }

    .ant-select-arrow {
        color: ${(props) =>
            props.theme?.colors?.secondary?.main?.icon ||
            baseTheme.colors.secondary.main.icon};
    }
`;
// DOCUMENT : second safe solution to change the arrow icon color and size (removed for using BiChevronDown as suffixIcon)
// .ant-select-arrow svg[data-icon='down'] {
//   transform: scaleY(0.7);
// }
